import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { DeliveryMethodListComponent } from './list/list.component';
import { AuthGuard } from '../auth/auth.guard';
import { DeliveryMethodService } from './delivery-method.service';
import { SharedModule } from '../shared/shared.module';
import { DeliveryMethodCreateComponent } from './create/create.component';
import { DeliveryMethodFormComponent } from './form/form.component';
import { DeliveryMethodEditComponent } from './edit/edit.component';

const routes: Routes = [
  {
    path: 'delivery-methods',
    component: DeliveryMethodListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'delivery-methods/create',
    component: DeliveryMethodCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'delivery-methods/:id/edit',
    component: DeliveryMethodEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    DeliveryMethodListComponent,
    DeliveryMethodCreateComponent,
    DeliveryMethodFormComponent,
    DeliveryMethodEditComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, DeliveryMethodService],
})
export class DeliveryMethodRoutingModule {}
